module.exports = __webpack_public_path__ + "static/media/profile_logo.bf26e40a.png";